import React, { useRef, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Alert, FloatingLabel } from 'react-bootstrap';
import RegBreadcrumb from '../components/RegBreadcrumb';
import PhoneInput from 'react-phone-input-2';
import { FieldArray, Formik } from 'formik';
import { TailSpin } from 'react-loader-spinner';
import * as Yup from "yup";

import { ageService } from '../functions/ageApi';
import { accountService } from '../functions/registerApi';
import { authService } from '../functions/authenticate';
import { promoService } from '../functions/promoApi';

import 'react-phone-input-2/lib/high-res.css';
import '../scss/RegisterMember.scss';
import '../scss/RegChart.scss';
import '../scss/Register.scss';


const Register = ({ userID, setUserID, marathonPrice, marathonLabel, setUserName, login, setLogin, authToken, setAuthToken, size, sst, tshirtTypeChangeStartDate, testAcc }) => {

    const navigate = useNavigate();

    // let tshirtCap = [250, 700, 10000, 10000, 10000, 1300, 550, 200, 165, 135];
    // let singletMaleCap = [120, 140, 300, 340, 260, 180, 140, 120, 100, 100];
    // let singletFemaleCap = [170, 260, 280, 260, 160, 150, 120, 100, 100, 100];
    // let finisher21Cap = [180, 300, 650, 1070, 830, 400, 220, 140, 110, 100];
    // let finisher42Cap = [150, 240, 345, 540, 360, 210, 140, 120, 105, 100];

    let tshirtCap = [198, 675, 1752, 2852, 2352, 1342, 595, 178, 93, 63];
    let singletMaleCap = [19, 37, 163, 238, 158, 75, 35, 18, 2, 2];
    let singletFemaleCap = [66, 147, 167, 148, 56, 46, 19, 2, 2, 1];
    let finisher21Cap = [90, 260, 658, 1128, 838, 328, 130, 35, 13, 2];
    let finisher42Cap = [40, 109, 244, 439, 254, 101, 32, 10, 5, 2];

    const [searchParams, setSearchParams] = useSearchParams();
    const countryList = require('../data/country.json');
    const [start, setStart] = useState(true);
    const [loading, setLoading] = useState(false);

    const [runner, setRunner] = useState(0);
    const [runners, setRunners] = useState({
        runner: [
            {
                firstname: '',
                lastname: '',
                gender: '',
                email: '',
                bibName: '',
                dob: '',
                nationality: '',
                mykad: '',
                contact: '',
                emergencyName: '',
                emergencyContact: '',
                medicalAttention: '',
                category: '',
                categoryType: 'Open',
                tshirt_type: '',
                tshirt_size: '',
                finisher: '',
                racePackCollection: 'Self-Collect',
                deliveryAddress: '',
                deliveryPostcode: '',
                deliveryCity: '',
                deliveryState: '',
                deliveryCountry: ''
            }
        ]
    });
    const [tempRunners, setTempRunners] = useState({
        runner: [
            {
                firstname: '',
                lastname: '',
                gender: '',
                email: '',
                bibName: '',
                dob: '',
                nationality: '',
                mykad: '',
                contact: '',
                emergencyName: '',
                emergencyContact: '',
                medicalAttention: '',
                category: '',
                categoryType: '',
                tshirt_type: '',
                tshirt_size: '',
                finisher: '',
                racePackCollection: ''
            }
        ]
    });

    const [isUpdate, setIsUpdate] = useState(false);
    const [showDiv, setShowDiv] = useState([false, false, false, false]);
    const [ageCheck, setAgeCheck] = useState([[false, false, false, false]]); // set the availability for each category 
    const [ageCheckVeteran, setAgeCheckVeteran] = useState([[false, false]]); // veteran check
    const [isMarathon, setIsMarathon] = useState([false]); // check if the run is 21 or 42
    const [categoryCheck, setCategoryCheck] = useState([false]);
    const [isMe, setIsMe] = useState(false);
    const [isMyAddress, setIsMyAddress] = useState(false);
    const [isDelivery, setIsDelivery] = useState([false]);
    const [hasTshirt, setHasTshirt] = useState([false, false, false, false, false, false, false, false, false, false]);
    const [hasTshirt2, setHasTshirt2] = useState([
        [false, false, false, false, false, false, false, false, false, false]
    ]);
    const [hasFinisher, setHasFinisher] = useState([
        [false, false, false, false, false, false, false, false, false, false]
    ]);
    const elementRef = useRef([]);
    const elementRef2 = useRef([]);

    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [notice, setNotice] = useState(false);
    const [noticeMessage, setNoticeMessage] = useState('');
    // item cart variables
    const [cartSubtotal, setSubtotal] = useState(0);
    const [cartTax, setCartTax] = useState(0);
    const [cartTotal, setCartTotal] = useState(0);

    const [promo, setPromo] = useState('');
    const [groupCode, setGroupCode] = useState('');

    // Enable T-shirt Type Change
    const [tshirtTypeEnable, setTshirtTypeEnable] = useState(false);

    // useEffect(() => {
    //     navigate('/Register');
    // });


    // initialize the react hook
    useEffect(() => {

        // let userId = localStorage.getItem('userID');
        let runner = localStorage.getItem('runnerCount');
        let runnerList = localStorage.getItem('runnerList');
        let newRunnerList = JSON.parse(localStorage.getItem('runnerList'));
        let newPromo = localStorage.getItem('promoCode') === null ? '' : localStorage.getItem('promoCode');

        var userAgent = userAgent = navigator.userAgent;
        userAgent = userAgent.toLowerCase();
        var Android = userAgent.indexOf("android") > -1;
        var iOS = userAgent.indexOf("ipad") > -1 || userAgent.indexOf("iphone") > -1 || userAgent.indexOf("ipod") > -1;

        let newLength = runner - (newRunnerList ? newRunnerList.length : 0);

        // Check where T-shirt Type Change is enable
        let today = new Date();
        let changeDt = new Date(tshirtTypeChangeStartDate);
        let tshirtTypeChangeEnable = false;
        if (today >= changeDt) {
            setTshirtTypeEnable(true);
            tshirtTypeChangeEnable = true;
        }

        setPromo(newPromo);
        promoFunction(newPromo);

        let newRunners = [];
        let newAgeCheck = [];
        let newIsMarathon = [];
        let newCategoryCheck = [];
        let newAgeCheckVeteran = [];
        let newIsDelivery = [];
        let newHasTshirt2 = [];
        let newHasFinisher = [];

        if (newLength > 0 && start) {
            for (var i = 0; i < newLength; i++) {
                const obj = {
                    firstname: '',
                    lastname: '',
                    gender: '',
                    email: '',
                    bibName: '',
                    dob: '',
                    nationality: '',
                    mykad: '',
                    contact: '',
                    emergencyName: '',
                    emergencyContact: '',
                    medicalAttention: '',
                    category: '',
                    categoryType: '',
                    // tshirt_type: tshirtTypeChangeEnable ? '' : 'T-shirt',
                    tshirt_type: '',
                    tshirt_size: '',
                    finisher: '',
                    racePackCollection: 'Self-Collect',
                    deliveryAddress: '',
                    deliveryPostcode: '',
                    deliveryCity: '',
                    deliveryState: '',
                    deliveryCountry: ''
                };
                newRunners.push(obj);

                const arr = [false, false, false, false];
                newAgeCheck.push(arr);

                const arr2 = false;
                newIsMarathon.push(arr2);

                const arr3 = false;
                newCategoryCheck.push(arr3);

                const arr4 = [false, false];
                newAgeCheckVeteran.push(arr4);

                const arr5 = false;
                newIsDelivery.push(arr5);

                newHasTshirt2.push([false, false, false, false, false, false, false, false, false, false]);

                // console.log(newRunners);

            }

            setRunners({ runner: newRunners });
            setAgeCheck(newAgeCheck);
            setAgeCheckVeteran(newAgeCheckVeteran);
            setIsMarathon(newIsMarathon);
            setCategoryCheck(newCategoryCheck);
            setIsDelivery(newIsDelivery);

            setHasTshirt2(newHasTshirt2);


            setStart(false);
        }

        if (runnerList !== null && runnerList !== '' && newRunnerList.length > 0) {

            newRunnerList.map((runner, index) => {
                const obj = {
                    firstname: runner.firstname,
                    lastname: runner.lastname,
                    gender: runner.gender,
                    email: runner.email,
                    bibName: runner.bibName,
                    dob: runner.dob,
                    nationality: runner.nationality,
                    mykad: runner.mykad,
                    contact: runner.contact,
                    emergencyName: runner.emergencyName,
                    emergencyContact: runner.emergencyContact,
                    medicalAttention: runner.medicalAttention,
                    category: runner.category,
                    categoryType: runner.categoryType,
                    tshirt_type: runner.tshirt_type,
                    tshirt_size: runner.tshirt_size,
                    finisher: runner.finisher,
                    racePackCollection: runner.racePackCollection,
                    deliveryAddress: runner.deliveryAddress,
                    deliveryPostcode: runner.deliveryPostcode,
                    deliveryCity: runner.deliveryCity,
                    deliveryState: runner.deliveryState,
                    deliveryCountry: runner.deliveryCountry,
                };
                newRunners.push(obj);

                var arr = [false, false, false, false];
                var arr2 = false;
                var arr3 = false;
                var arr4 = [false, false];
                var arr5 = false;

                const age = ageService.calculateAge(runner.dob);
                updateAge(age, index);

                if (age >= 40) {
                    arr = [true, true, true, true];
                    arr4 = [true, true];
                }
                else if (age >= 18 && age < 40) {
                    arr = [true, true, true, true];
                    arr4 = [true, false];
                }
                else if (age >= 16 && age < 18) {
                    arr = [false, true, true, true];
                    arr4 = [true, false];
                }
                else if (age >= 15 && age < 16) {
                    arr = [false, false, true, true];
                    arr4 = [true, false];
                }
                else if (age >= 7 && age < 15) {
                    arr = [false, false, false, true];
                    arr4 = [true, false];
                }
                else {
                    arr = [false, false, false, false];
                    arr4 = [false, false];
                }

                switch (runner.category) {
                    case '42KM':
                        arr2 = true;
                        arr3 = true;
                        break;

                    case '21KM':
                        arr2 = true;
                        arr3 = true;
                        break;

                    case '10KM':
                        arr2 = false;
                        arr3 = true;
                        break;

                    case '5KM':
                        arr2 = false;
                        arr3 = true;
                        break;

                    default:
                        arr2 = false;
                        arr3 = false;
                        break;
                }

                if (runner.racePackCollection === "Delivery Service") {
                    arr5 = true;
                }

                newAgeCheck.push(arr);
                newIsMarathon.push(arr2);
                newCategoryCheck.push(arr3);
                newAgeCheckVeteran.push(arr4);
                newIsDelivery.push(arr5);

                newHasTshirt2.push([false, false, false, false, false, false, false, false, false, false]);
                newHasFinisher.push([false, false, false, false, false, false, false, false, false, false]);

            });

            setAgeCheck(newAgeCheck);
            setIsMarathon(newIsMarathon);
            setCategoryCheck(newCategoryCheck);
            setAgeCheckVeteran(newAgeCheckVeteran);
            setIsDelivery(newIsDelivery);
            setHasTshirt2(newHasTshirt2);
            setHasFinisher(newHasFinisher);

            setRunners({ runner: newRunners });

        }



    }, []);


    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (token === '' || token === null) {
            navigate('/Login');
        }
        else {
            // console.log(token);
            authService.validateAuthToken(token)
                .then((response) => {
                    // console.log(response);
                    if (!response.status) {
                        navigate('/Login');
                    }
                    else if (!login) {
                        let data = response.body.user;
                        setUserID(data.individualID);
                        localStorage.setItem('userID', data.individualID);
                        // console.log(localStorage.getItem('userID'));
                        setLogin(true);

                        setUserName(data.firstname + ' ' + data.lastname);
                        localStorage.setItem('userName', data.firstname + ' ' + data.lastname);

                        setAuthToken(response.body.token);
                        localStorage.setItem('authToken', response.body.token);

                        if (testAcc.indexOf(data.individualID) !== -1) {
                            setTshirtTypeEnable(true);
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    navigate('/Login');
                })
        }

        let paymentID = localStorage.getItem('paymentID') === null ? '' : localStorage.getItem('paymentID');

    }, [authToken]);

    useEffect(() => {
        if (searchParams.get('updateToken') && searchParams.get('updateToken') !== null && searchParams.get('updateToken') !== '') {
            let updateToken = searchParams.get('updateToken');
            var data = authService.decryptUpdateToken(updateToken);

            if (data !== false && data.userID === userID) {
                let newRunners = [];
                let newRunnerList = JSON.parse(localStorage.getItem('runnerList'));

                newRunnerList.map(runner => {
                    const obj = {
                        firstname: runner.firstname,
                        lastname: runner.lastname,
                        gender: runner.gender,
                        email: runner.email,
                        bibName: runner.bibName,
                        dob: runner.dob,
                        nationality: runner.nationality,
                        mykad: runner.mykad,
                        contact: runner.contact,
                        emergencyName: runner.emergencyName,
                        emergencyContact: runner.emergencyContact,
                        medicalAttention: runner.medicalAttention,
                        category: runner.category,
                        categoryType: runner.categoryType,
                        tshirt_size: runner.tshirt_size,
                        finisher: runner.finisher,
                        racePackCollection: 'Self-Collect',
                        deliveryAddress: '',
                        deliveryPostcode: '',
                        deliveryCity: '',
                        deliveryState: '',
                        deliveryCountry: ''
                    };
                    newRunners.push(obj);
                });

                setTempRunners({ runner: newRunners });
                setIsUpdate(true);
            }
        }
    }, [userID]);


    const handleIsMeCheck = (e) => {
        let status = e.target.checked;
        setIsMe(status);

        if (status) {
            let userId = localStorage.getItem('userID');

            accountService.getUser(userId)
                .then(response => {
                    // console.log(response);

                    if (response.status) {
                        const data = response.body.user;
                        let newRunners = [...runners.runner];

                        const age = ageService.calculateAge(data.dob);

                        // console.log(data);

                        const obj = {
                            firstname: data.firstname,
                            lastname: data.lastname,
                            gender: data.gender,
                            email: data.email,
                            bibName: '',
                            dob: data.dob,
                            nationality: data.nationality,
                            mykad: data.mykad,
                            contact: data.phone_no,
                            emergencyName: '',
                            emergencyContact: '',
                            medicalAttention: '',
                            category: '',
                            categoryType: age >= 40 ? 'Veteran' : 'Open',
                            tshirt_size: '',
                            tshirt_type: 'T-shirt',
                            finisher: '',
                            racePackCollection: 'Self-Collect',
                            deliveryAddress: '',
                            deliveryPostcode: '',
                            deliveryCity: '',
                            deliveryState: '',
                            deliveryCountry: ''
                        }
                        // console.log(obj);

                        newRunners[0] = obj
                        setRunners({ runner: newRunners });

                    }
                    else {
                        const err = response.body;
                        setError(true);
                        setErrorMessage(err.message);
                    }
                })
                .catch(err => console.error(err));
        }
    }
    useEffect(() => {
        // console.log(runners.runner.length);
        handleCap();
        if (runners.runner.length > 0) {
            runners.runner.map((runner, i) => {
                var dob = runner.dob;
                if (dob !== '' && dob !== null) {
                    const age = ageService.calculateAge(dob);
                    updateAge(age, i);
                }
            })
        }
        calculateTotal();
    }, [runners]);

    const handleGender = (e, index) => {
        var gender = e.target.value;
        let newRunner = [...runners.runner];

        newRunner[index].gender = gender;
        setRunners({ runner: newRunner });
    }

    const handleMarathonTypeCheck = (e, index) => {
        var marathonType = e.target.value;
        updateMarathonTypeCheck(marathonType, index);
    }
    function updateMarathonTypeCheck(marathonType, index) {
        let newIsMarathon = [...isMarathon];
        let newCategoryCheck = [...categoryCheck];
        let newRunner = [...runners.runner];

        newRunner[index].categoryType = '';
        const age = ageService.calculateAge(newRunner[index].dob);

        switch (marathonType) {
            case '42KM':
                newIsMarathon[index] = true;
                newCategoryCheck[index] = true;
                newRunner[index].category = '42KM';
                newRunner[index].categoryType = age >= 40 ? 'Veteran' : 'Open';
                break;

            case '21KM':
                newIsMarathon[index] = true;
                newCategoryCheck[index] = true;
                newRunner[index].category = '21KM';
                newRunner[index].categoryType = age >= 40 ? 'Veteran' : 'Open';
                break;

            case '10KM':
                newIsMarathon[index] = false;
                newCategoryCheck[index] = true;
                newRunner[index].category = '10KM';
                newRunner[index].categoryType = 'Open';
                break;

            case '5KM':
                newIsMarathon[index] = false;
                newCategoryCheck[index] = true;
                newRunner[index].category = '5KM';
                newRunner[index].categoryType = 'Open';
                break;

            default:
                newIsMarathon[index] = false;
                newCategoryCheck[index] = false;
                newRunner[index].category = '';
                newRunner[index].categoryType = 'Open';
                break;
        }

        setIsMarathon(newIsMarathon);
        setCategoryCheck(newCategoryCheck);
        setRunners({ runner: newRunner });

        // console.log(marathonType);
    }

    const handleCategoryTypeCheck = (e, index) => {
        var categoryType = e.target.value;
        // console.log(categoryType);
        updateCategoryTypeCheck(categoryType, index)
    }
    function updateCategoryTypeCheck(categoryType, index) {
        let newRunner = [...runners.runner];
        // console.log(newRunner[index].categoryType);

        // newRunner[index].categoryType = categoryType;
        if (categoryType === 'Open') {
            newRunner[index].categoryType = 'Open';
        }
        else {
            newRunner[index].categoryType = 'Veteran';
        }

        // console.log(newRunner[index].categoryType);
        // console.log(newRunner);

        setRunners({ runner: newRunner });
    }

    const handleShirtTypeCheck = (e, index) => {
        var shirtType = e.target.value;
        let newRunner = [...runners.runner];

        newRunner[index].tshirt_type = shirtType;
        setRunners({ runner: newRunner });
    }
    const handleTshirtCheck = (e, index) => {
        var tshirt = e.target.value;
        let newRunner = [...runners.runner];

        switch (tshirt) {
            case '2XS':
                newRunner[index].tshirt_size = '2XS';
                break;
            case 'XS':
                newRunner[index].tshirt_size = 'XS';
                break;
            case 'S':
                newRunner[index].tshirt_size = 'S';
                break;
            case 'M':
                newRunner[index].tshirt_size = 'M';
                break;
            case 'L':
                newRunner[index].tshirt_size = 'L';
                break;
            case 'XL':
                newRunner[index].tshirt_size = 'XL';
                break;
            case '2XL':
                newRunner[index].tshirt_size = '2XL';
                break;
            case '3XL':
                newRunner[index].tshirt_size = '3XL';
                break;
            case '4XL':
                newRunner[index].tshirt_size = '4XL';
                break;
            case '5XL':
                newRunner[index].tshirt_size = '5XL';
                break;
            default:
                newRunner[index].tshirt_size = '';
                break;
        }

        setRunners({ runner: newRunner });
    }
    const handleFinisher = (e, index) => {
        var finisher = e.target.value;
        let newRunner = [...runners.runner];

        switch (finisher) {
            case '2XS':
                newRunner[index].finisher = '2XS';
                break;
            case 'XS':
                newRunner[index].finisher = 'XS';
                break;
            case 'S':
                newRunner[index].finisher = 'S';
                break;
            case 'M':
                newRunner[index].finisher = 'M';
                break;
            case 'L':
                newRunner[index].finisher = 'L';
                break;
            case 'XL':
                newRunner[index].finisher = 'XL';
                break;
            case '2XL':
                newRunner[index].finisher = '2XL';
                break;
            case '3XL':
                newRunner[index].finisher = '3XL';
                break;
            case '4XL':
                newRunner[index].finisher = '4XL';
                break;
            case '5XL':
                newRunner[index].finisher = '5XL';
                break;
            default:
                newRunner[index].finisher = '';
                break;
        }

        setRunners({ runner: newRunner });
    }
    function calculateTotal() { // Calculate the total amount of the item cart
        var subtotal = 0;
        var tax = 0;
        var total = 0;

        runners.runner.map((values, index) => {
            if (values.category !== '') {
                subtotal += marathonPrice[values.category];
                subtotal += values.racePackCollection == "Delivery Service" ? 20 : 0;
            }
            // console.log(values);
        });

        tax = subtotal * sst;
        total = subtotal + tax;

        setSubtotal(subtotal.toFixed(2));
        setCartTax(tax.toFixed(2));
        setCartTotal(total.toFixed(2));
        // console.log(marathonPrice['42KM']);
    }
    const handleAge = (e, index) => {
        let newRunner = [...runners.runner];
        newRunner[index].dob = e.target.value;
        setRunners({ runner: newRunner });

        const age = ageService.calculateAge(e.target.value);

        updateAge(age, index);
    }
    function updateAge(age, index) { // update the check status of the marathon type based on age
        var newAgeCheck = [false, false, false, false];
        var newAgeCheckVeteran = [false, false];
        let newRunner = [...runners.runner];
        var isRunnerUpdate = false;

        if (age >= 40) {
            newAgeCheck = [true, true, true, true];
            newAgeCheckVeteran = (runners.runner[index].category === "42KM" || runners.runner[index].category === "21KM") ? [true, true] : [true, false];
            if (runners.runner[index].category === "42KM" || runners.runner[index].category === "21KM") {
                newAgeCheckVeteran = [true, true];
                if (newRunner[index].categoryType === "Open") {
                    newRunner[index].categoryType = "Veteran";
                    isRunnerUpdate = true;
                }
            } else {
                newAgeCheckVeteran = [true, false];
                if (newRunner[index].categoryType === "Veteran") {
                    newRunner[index].categoryType = "Open";
                    isRunnerUpdate = true;
                }
            }
        }
        else if (age >= 18 && age < 40) {
            newAgeCheck = [true, true, true, true];
            newAgeCheckVeteran = [true, false];
        }
        else if (age >= 16 && age < 18) {
            newAgeCheck = [false, true, true, true];
            newAgeCheckVeteran = [true, false];
        }
        else if (age >= 15 && age < 16) {
            newAgeCheck = [false, false, true, true];
            newAgeCheckVeteran = [true, false];
        }
        else if (age >= 7 && age < 15) {
            newAgeCheck = [false, false, false, true];
            newAgeCheckVeteran = [true, false];
        }
        else {
            newAgeCheck = [false, false, false, false];
            newAgeCheckVeteran = [false, false];
        }


        // console.log(age);
        // console.log(newAgeCheckVeteran);

        let newArr = [...ageCheck];
        newArr[index] = newAgeCheck;
        setAgeCheck(newArr);

        let newArr2 = [...ageCheckVeteran];
        newArr2[index] = newAgeCheckVeteran;
        setAgeCheckVeteran(newArr2);

        if (isRunnerUpdate) {
            setRunners({ runner: newRunner });
        }

    }

    const handleDelivery = (e, index) => {
        var deliveryMethod = e.target.value;
        let newRunner = [...runners.runner];
        let newIsDelivery = [...isDelivery];

        // console.log(deliveryMethod);

        if (deliveryMethod === 'Delivery Service') {
            newIsDelivery[index] = true;
        } else {
            newIsDelivery[index] = false;
        }

        setIsDelivery(newIsDelivery);

        newRunner[index].racePackCollection = deliveryMethod;
        setRunners({ runner: newRunner });

    }

    const handleIsMyAddress = (e, index) => {
        let status = e.target.checked;
        setIsMyAddress(status);

        if (status) {
            let userId = localStorage.getItem('userID');

            accountService.getUser(userId)
                .then(response => {
                    // console.log(response);

                    if (response.status) {
                        const data = response.body.user;
                        let newRunners = [...runners.runner];

                        const age = ageService.calculateAge(data.dob);

                        // console.log(data);

                        newRunners[index].deliveryAddress = data.address;
                        newRunners[index].deliveryPost = data.postcode;
                        newRunners[index].deliveryCity = data.city;
                        newRunners[index].deliveryState = data.state;
                        newRunners[index].deliveryCountry = data.country;

                        setRunners({ runner: newRunners });

                    }
                    else {
                        const err = response.body;
                        setError(true);
                        setErrorMessage(err.message);
                    }
                })
                .catch(err => console.error(err));
        }
    }

    const handleCap = () => {

        accountService.getShirtCap()
            .then((response) => {

                // console.log(response);

                var tempArr1 = [false, false, false, false, false, false, false, false, false, false];
                var tempArr2 = [false, false, false, false, false, false, false, false, false, false];
                var tempArr3 = [false, false, false, false, false, false, false, false, false, false];
                var tempArr4 = [false, false, false, false, false, false, false, false, false, false];
                var tempArr5 = [false, false, false, false, false, false, false, false, false, false];

                let cap = response.body;
                let sizeArr = ['2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
                let tshirtSelected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                let singletMaleSelected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                let singletFemaleSelected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                let finisher21Selected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                let finisher42Selected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

                let runnerList = localStorage.getItem('runnerList');
                let newRunnerList = JSON.parse(localStorage.getItem('runnerList'));
                let newLength = 0;

                if (runnerList !== null && runnerList !== '' && newRunnerList.length > 0) {
                    newLength = newRunnerList.length;
                } else {
                    newLength = runners.runner.length;
                }

                for (var i = 0; i < newLength; i++) {
                    let index = sizeArr.indexOf(runners.runner[i].tshirt_size);
                    if (index >= 0) {
                        if (runners.runner[i].tshirt_type == "T-shirt") {
                            tshirtSelected[index]++;
                        } else if (runners.runner[i].tshirt_type == "Singlet") {
                            if (runners.runner[i].gender == "Male") {
                                singletMaleSelected[index]++;
                            } else {
                                singletFemaleSelected[index]++;
                            }
                        }
                    }

                    if (runners.runner[i].race_cat === '21KM') {
                        let index = sizeArr.indexOf(runners.runner[i].finisher);
                        if (index > 0) finisher21Selected[index]++;
                    } else if (runners.runner[i].race_cat === '42KM') {
                        let index = sizeArr.indexOf(runners.runner[i].finisher);
                        if (index > 0) finisher42Selected[index]++;
                    }

                }

                for (var i = 0; i < sizeArr.length; i++) {

                    var temp1 = parseInt(tshirtCap[i]) - parseInt(cap.tshirt[i]) - parseInt(tshirtSelected[i]);
                    // console.log(temp1);
                    if (temp1 > 0) {
                        tempArr1[i] = true;
                    }

                    var temp4 = parseInt(singletMaleCap[i]) - parseInt(cap.singletMale[i]) - parseInt(singletMaleSelected[i]);
                    // console.log(temp1);
                    if (temp4 > 0) {
                        tempArr4[i] = true;
                    }

                    var temp5 = parseInt(singletFemaleCap[i]) - parseInt(cap.singletFemale[i]) - parseInt(singletFemaleSelected[i]);
                    // console.log(temp1);
                    if (temp5 > 0) {
                        tempArr5[i] = true;
                    }

                    var temp2 = parseInt(finisher21Cap[i]) - parseInt(cap.finisher21[i]) - parseInt(finisher21Selected[i]);
                    // console.log(temp2);
                    if (temp2 > 0) {
                        tempArr2[i] = true;
                    }

                    var temp3 = parseInt(finisher42Cap[i]) - parseInt(cap.finisher42[i]) - parseInt(finisher42Selected[i]);
                    // console.log(temp3);
                    if (temp3 > 0) {
                        tempArr3[i] = true;
                    }

                }

                // console.log(tempArr2);
                // console.log(tempArr5);
                // console.log(newLength);

                let newHasTshirt = [];
                let newHasFinisher = [];
                for (var i = 0; i < newLength; i++) {

                    if (runners.runner[i].tshirt_type == "T-shirt") {
                        newHasTshirt.push(tempArr1);
                    } else if (runners.runner[i].tshirt_type == "Singlet") {
                        if (runners.runner[i].gender == "Male") {
                            newHasTshirt.push(tempArr4);
                        } else {
                            newHasTshirt.push(tempArr5);
                        }
                    } else {
                        newHasTshirt.push([false, false, false, false, false, false, false, false, false, false]);
                    }

                    if (runners.runner[i].category === '21KM') {
                        newHasFinisher.push(tempArr2);
                    } else if (runners.runner[i].category === '42KM') {
                        newHasFinisher.push(tempArr3);
                    } else {
                        newHasFinisher.push([false, false, false, false, false, false, false, false, false, false]);
                    }

                }


                // console.log(newLength);
                // console.log(newHasTshirt);

                // setHasTshirt(tempArr1);
                setHasTshirt2(newHasTshirt);
                setHasFinisher(newHasFinisher);

            })
            .catch((error) => {
                console.log(error);
            })
    }

    Yup.addMethod(Yup.array, 'unique', function (message, mapper = a => a) {
        return this.test('unique', message, function (list) {
            return list.length === new Set(list.map(mapper)).size;
        });
    });

    // Yup validation schema
    const validateSchema = Yup.object().shape({
        runner: Yup.array().of(
            Yup.object().shape({
                firstname: Yup.string()
                    .required("First name is required"),

                lastname: Yup.string()
                    .required("Last name is required"),

                email: Yup.string()
                    .email("Invalid email format")
                    .required("Email is required"),

                // bibName: Yup.string()
                //     .required("Bib name is required"),

                gender: Yup.string().required("Gender is required"),

                dob: Yup.date()
                    .max(new Date(), "Invalid date of birth, the date must be earlier than today")
                    .required("Birth date is required"),

                nationality: Yup.string()
                    .required("Nationality is required"),

                contact: Yup.string()
                    // .min(15, "Invalid contact number!")
                    .required("Contact number is required"),

                mykad: Yup.string()
                    .required("Identity Card / Passport is required"),

                emergencyName: Yup.string()
                    .min(2, "Too Short!")
                    .max(200, "Too Long!")
                    .required("Emergency contact person's name is required"),

                emergencyContact: Yup.string()
                    // .min(15, "Invalid contact number!")
                    .required("Emergency contact number is required"),

                category: Yup.string().required("Marathon category is required"),

                categoryType: Yup.string().required("Category type is required"),

                tshirt_type: Yup.string().required("T-shirt type is required"),

                tshirt_size: Yup.string().required("T-shirt size is required"),

                finisher: Yup.mixed()
                    .when("category", {
                        is: (category) => (category === '42KM' || category === '21KM'),
                        then: () => Yup.string().required("Finisher size is required"),
                        otherwise: () => Yup.string(),
                    }),
                // .when("category", {
                //     is: (category) => category==='21KM',
                //     then: (finisher) => Yup.string().required("Finisher size is required"),
                //     otherwise: () => Yup.string(),
                // }),

                deliveryAddress: Yup.mixed()
                    .when("racePackCollection", {
                        is: (racePackCollection) => racePackCollection === 'Delivery Service',
                        then: () => Yup.string().required("Delivery address is required"),
                        otherwise: () => Yup.string(),
                    }),

                deliveryPostcode: Yup.mixed()
                    .when("racePackCollection", {
                        is: (racePackCollection) => racePackCollection === 'Delivery Service',
                        then: () => Yup.string().required("Delivery postcode is required"),
                        otherwise: () => Yup.string(),
                    }),

                deliveryCity: Yup.mixed()
                    .when("racePackCollection", {
                        is: (racePackCollection) => racePackCollection === 'Delivery Service',
                        then: () => Yup.string().required("Delivery city is required"),
                        otherwise: () => Yup.string(),
                    }),

                deliveryState: Yup.mixed()
                    .when("racePackCollection", {
                        is: (racePackCollection) => racePackCollection === 'Delivery Service',
                        then: () => Yup.string().required("Delivery state is required"),
                        otherwise: () => Yup.string(),
                    }),

                deliveryCountry: Yup.mixed()
                    .when("racePackCollection", {
                        is: (racePackCollection) => racePackCollection === 'Delivery Service',
                        then: () => Yup.string().required("Delivery country is required"),
                        otherwise: () => Yup.string(),
                    }),
            })
        )
            .unique("Duplicated IC/Passport detected!", (a) => a.mykad)
    });

    const handlePromo = (e) => {
        setPromo(e.target.value);
        localStorage.setItem('promoCode', e.target.value);

        // let newRunner = [...runners.runner];
        // let len = newRunner.length;
        // for(var i=0; i<len; i++){
        //     newRunner[i].category = '';
        // }
        // setRunners({runner: newRunner});

        promoFunction(e.target.value);

    }

    const promoFunction = (value) => {

        setGroupCode('');
        promoService.getPromoDetail(value)
            .then((response) => {

                // console.log(response);

                if (response.status) {
                    let catArr = ["42KM", "21KM", "10KM", "5KM"];
                    let temp = [true, true, true, true];
                    let type = response.body.type;
                    let promoValidity = false;
                    let msgCode = "";

                    if (type === 1) {
                        promoValidity = true;
                        msgCode = "Promo Code ";
                    } else if (type === 2) {
                        msgCode = "Group Code ";
                        let quota = response.body.quota;
                        if (quota.remain >= parseInt(runners.runner.length)) {
                            promoValidity = true;
                        } else {
                            alert('You had exceed the quota of the participants (' + quota.quantity + ' runners) you can register. ' + response.body.code + ' has been used to register ' + quota.registered + ' participant(s).');
                            localStorage.removeItem('promoCode');
                            navigate('/Register');
                        }
                    }

                    if (promoValidity) {
                        let category = response.body.category;
                        category.forEach((cat, i) => {
                            let index = catArr.indexOf(cat);
                            temp[index] = false;
                        });

                        if (msgCode === "Group Code ") {
                            setShowDiv(temp);
                            setGroupCode(response.body.code);

                            var deliveryMethod = "Self-Collect";
                            let newRunner = [...runners.runner];
                            let newIsDelivery = [...isDelivery];
                            for (var i = 0; i < newIsDelivery.length; i++) {
                                newIsDelivery[i] = false;
                                newRunner[i].racePackCollection = deliveryMethod;
                            }
                            setIsDelivery(newIsDelivery);
                            setRunners({ runner: newRunner });

                        } else {
                            setPromo(response.body.code);
                            localStorage.setItem('promoCode', response.body.code);
                        }
                        setNoticeMessage(msgCode + response.body.code + ' has been applied.');
                        setNotice(true);
                    }
                } else {
                    let temp = [false, false, false, false];
                    setShowDiv(temp);
                    setNotice(false);
                    setNoticeMessage('');
                }

            })
            .catch((err) => {
                console.error(err.response);
            })

    }

    // On submit handler
    const submitForm = (values) => {
        setLoading(true);
        let userId = localStorage.getItem('userID');
        let paymentID = localStorage.getItem('paymentID') === null ? '' : localStorage.getItem('paymentID');
        let platform = localStorage.getItem('device') === null ? '' : localStorage.getItem('device');

        // console.log(platform);
        // console.log(values.runner);

        if (window.confirm("Please confirm that all information provided is correct. Not changes is allowd after this.")) {
            if (groupCode == '') {

                accountService.checkRegistration(values.runner)
                    .then((response) => {

                        console.log(response);

                        if (response.status) {

                            let res = response.body;
                            // console.log(res);
                            if (res.registered) {
                                // list of registered runner
                                let runners = res.data;
                                let err_message = "";
                                let index = 1;

                                // console.log(runners.length);

                                err_message += runners[0];
                                if (runners.length > 2) {
                                    for (var i = 1; i < runners.length - 1; i++) {
                                        err_message = err_message + ", " + runners[i];
                                        index++;
                                    }
                                }
                                if (runners.length > 1) {
                                    err_message = err_message + " and " + runners[index];
                                }

                                err_message += " already registered before. No duplicate registration allow.";

                                // console.error(err_message);
                                setError(true);
                                setErrorMessage(err_message);
                                setLoading(false);
                                window.scrollTo(0, 0);

                            } else {
                                //get and update the current runner list in local storage
                                let newRunnerList = [];
                                response.body.runners.map((value) => newRunnerList.push(value));
                                localStorage.setItem('runnerList', JSON.stringify(newRunnerList));
                                // update the promo code applied
                                localStorage.setItem('promoCode', promo);

                                setLoading(false);
                                navigate('/Cart');
                            }

                        } else {
                            // console.error(response.body);
                            // console.error("FULL ERROR:", err);
                            // console.error("MESSAGE:", err?.message);
                            // console.error("STACK:", err?.stack);

                            // setError(true);
                            // setErrorMessage(err?.message || "An unexpected error occurred.");
                            // setLoading(false);
                        }

                    }).catch(err => {
                        // console.error(err.response);
                        // setError(true);
                        // setErrorMessage(err.message);
                        // setLoading(false);

                        console.error("FULL ERROR:", err);
                        console.error("MESSAGE:", err?.message);
                        console.error("STACK:", err?.stack);

                        setError(true);
                        setErrorMessage(err?.message || "An unexpected error occurred.");
                        setLoading(false);
                    });

            } else {

                accountService.registerGroupRunner(values.runner, groupCode)
                    .then((response) => {

                        console.log(response);
                        let res = response.body;

                        if (res.registered) {
                            // list of registered runner
                            let runners = res.data;
                            let err_message = "";
                            let index = 1;

                            // console.log(runners.length);

                            err_message += runners[0];
                            if (runners.length > 2) {
                                for (var i = 1; i < runners.length - 1; i++) {
                                    err_message = err_message + ", " + runners[i];
                                    index++;
                                }
                            }
                            if (runners.length > 1) {
                                err_message = err_message + " and " + runners[index];
                            }

                            err_message += " already registered before. No duplicate registration allow.";

                            // console.error(err_message);
                            setError(true);
                            setErrorMessage(err_message);
                            setLoading(false);
                            window.scrollTo(0, 0);

                        } else {

                            navigate('/GroupRegistrationDone/' + groupCode);

                        }

                    }).catch(err => {
                        console.error(err.response);
                        setError(true);
                        setErrorMessage(err.message);
                        setLoading(false);
                    });

            }
        }





        // accountService.registerMarathon(userId, values, promo, paymentID, platform)
        //     .then((response) => {
        //         // console.log(response);

        //         if(response.status)
        //         {
        //             if(response.body.pay_status) {

        //                 setLoading(false);
        //                 navigate('/PaymentDone/' + response.body.paymentID);

        //             } else {

        //                 // get and update the current runner list in local storage
        //                 let newRunnerList = [];
        //                 response.body.runners.map((value) => newRunnerList.push(value));
        //                 localStorage.setItem('runnerList', JSON.stringify(newRunnerList));
        //                 // update the promo code applied
        //                 localStorage.setItem('promoCode', promo);
        //                 // set the current paymentID
        //                 localStorage.setItem('paymentID', response.body.paymentID);

        //                 setLoading(false);
        //                 navigate('/Cart');

        //             }

        //         }
        //         else
        //         {
        //             console.error(response.body.message);
        //             setError(true);
        //             setErrorMessage(response.body.message);
        //             setLoading(false);
        //             window.scrollTo(0, 0);
        //         }

        //     })
        //     .catch(err => {
        //         console.error(err.response);
        //         setError(true);
        //         setErrorMessage(err.message);
        //         setLoading(false);
        //     });

    }

    return (
        <Container fluid="lg" className='wrapper'>
            <h1 className="title">Marathon Registration</h1>

            <RegBreadcrumb page={1} />

            <br />

            {/* <Col md={12} xs={12}>
                <Alert variant="danger">
                    Registrations made after <b>15<sup>th</sup> August</b> will not include a printed name on the running bib; participants will receive a blank bib instead.
                    <br />
                    CONTACT US : <a href="mailto:support@marathonkuching.com">support@marathonkuching.com</a>
                </Alert>
            </Col> */}

            <Formik
                enableReinitialize
                initialValues={runners}
                validationSchema={validateSchema}
                onSubmit={submitForm}
            >
                {({ values, handleChange, handleSubmit, errors, touched, handleBlur, isValid, dirty }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Row className="runner-detail mb-5">
                            <Col md={8} xs={12} >

                                <FieldArray
                                    name="runners"
                                >
                                    {arrayHelpers => (
                                        <>
                                            {values.runner && values.runner.length > 0 && values.runner.map((runner, index) => (
                                                <div key={index}>
                                                    {/* {console.log(errors)} */}
                                                    {/* {values && values.runner && console.log(values.runner)} */}
                                                    {/* {console.log(runners)} */}
                                                    {/* {console.log(hasTshirt2)} */}

                                                    <h3 className="short-title "  >Runner {index + 1}</h3>

                                                    {index === 0 && (
                                                        <>
                                                            <Form.Group className="mb-3" id="formGridCheckbox">
                                                                <Form.Check type="checkbox" label="I'm the runner" onChange={handleIsMeCheck} checked={isMe} />
                                                            </Form.Group>
                                                        </>
                                                    )}


                                                    <div className="regForm mb-4">
                                                        <Row className="mb-3">
                                                            <h4>Runner's Details</h4>
                                                            <hr />
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="6" >
                                                                <FloatingLabel controlId={`firstnameLabel${index}`} label="First name">
                                                                    <Form.Control
                                                                        required
                                                                        name={`runner.${index}.firstname`}
                                                                        type="text"
                                                                        placeholder="First name"
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={values.runner[index].firstname}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].firstname &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].firstname
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].firstname
                                                                        }

                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].firstname}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            <Form.Group className="mb-2" as={Col} md="6" >
                                                                <FloatingLabel controlId={`lastnameLabel${index}`} label="Last name">
                                                                    <Form.Control
                                                                        required
                                                                        name={`runner.${index}.lastname`}
                                                                        type="text"
                                                                        placeholder="Last name"
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={values.runner[index].lastname}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].lastname &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].lastname
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].lastname
                                                                        }

                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].lastname}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="6" >
                                                                <FloatingLabel controlId={`emailLabel${index}`} label="Email">
                                                                    <Form.Control
                                                                        required
                                                                        name={`runner.${index}.email`}
                                                                        type="text"
                                                                        placeholder="Email"
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={values.runner[index].email}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].email &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].email
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].email
                                                                        }
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].email}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            {/*
                                                            <Form.Group className="mb-2" as={Col} md="6" >
                                                                <FloatingLabel controlId={`bibNameLabel${index}`} label="Bib Name">
                                                                    <Form.Control
                                                                        required
                                                                        name={`runner.${index}.bibName`}
                                                                        type="text"
                                                                        placeholder="Bib Name"
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={values.runner[index].bibName}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].bibName &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].bibName
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].bibName
                                                                        }
                                                                        disabled={true} // bib name function closed
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].bibName}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            */}
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="4"  >
                                                                <FloatingLabel controlId={`dobLabel${index}`} label="Date of Birth">
                                                                    <Form.Control
                                                                        required
                                                                        name={`runner.${index}.dob`}
                                                                        type="date"
                                                                        // placeholder="dob"
                                                                        // onChange={handleAge}
                                                                        onChange={(e) => {
                                                                            handleChange(e)
                                                                            handleAge(e, index)
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        value={values.runner[index].dob}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].dob &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].dob
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].dob
                                                                        }
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].dob}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            <Form.Group className="mb-2" as={Col} md="3"  >
                                                                <FloatingLabel controlId={`genderLabel${index}`} label="Gender">
                                                                    <Form.Select
                                                                        aria-label="Default select example"
                                                                        name={`runner.${index}.gender`}
                                                                        onChange={(e) => {
                                                                            handleChange(e);
                                                                            handleGender(e, index);
                                                                        }}
                                                                        value={values.runner[index].gender}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].gender &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].gender
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].gender
                                                                        }
                                                                    >
                                                                        <option style={{ background: '#fff', color: '#777' }} key="" value="">Gender</option>
                                                                        <option style={{ background: '#fff', color: '#777' }} key="Male" value="Male">Male</option>
                                                                        <option style={{ background: '#fff', color: '#777' }} key="Female" value="Female">Female</option>
                                                                    </Form.Select>
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].gender}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            <Form.Group className="mb-2" as={Col} md="5"  >
                                                                <FloatingLabel controlId={`nationalityLabel${index}`} label="Nationality">
                                                                    <Form.Select
                                                                        aria-label="Default select example"
                                                                        name={`runner.${index}.nationality`}
                                                                        onChange={handleChange}
                                                                        value={values.runner[index].nationality}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].nationality &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].nationality
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].nationality
                                                                        }
                                                                    >
                                                                        <option style={{ background: '#fff', color: '#777' }} key="" value="">Nationality</option>
                                                                        {
                                                                            countryList.map(data => (
                                                                                <option style={{ background: '#fff', color: '#777' }} key={data.country} value={data.country}>{data.country}</option>
                                                                            ))
                                                                        }
                                                                    </Form.Select>
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].nationality}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group as={Col} md="5" className="mb-2" >
                                                                <FloatingLabel controlId={`runner.${index}.mykad`} label="IC / Passport">
                                                                    <Form.Control
                                                                        required
                                                                        name={`runner.${index}.mykad`}
                                                                        type="text"
                                                                        placeholder="IC / Passport"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.runner[index].mykad}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].mykad &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].mykad
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].mykad
                                                                        }
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].mykad}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            <Form.Group as={Col} md="5" className="mb-2 phone-float-input" >
                                                                <FloatingLabel controlId={`runner.${index}.contact`} label="Contact No">
                                                                    <PhoneInput
                                                                        id="select-input"
                                                                        name={`runner.${index}.contact`}
                                                                        className={
                                                                            "form-control " +
                                                                            (errors && errors.runner && errors.runner[index] && !!errors.runner[index].contact ? "is-invalid" : "") + " " +
                                                                            (touched.runner && touched.runner[index] && touched.runner[index].contact && errors && errors.runner && errors.runner[index] && !errors.runner[index].contact ? "is-valid" : "")
                                                                        }
                                                                        country={'my'}
                                                                        inputProps={{
                                                                            name: `runner.${index}.contact`,
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        onChange={(phoneNumber, country, e) => { handleChange(e) }}
                                                                        value={values.runner[index].contact}
                                                                    />
                                                                    <Form.Control isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].contact} hidden />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].contact}</Form.Control.Feedback>
                                                                </FloatingLabel>

                                                            </Form.Group>
                                                        </Row>

                                                        <br /><br />

                                                        <Row className="mb-3">
                                                            <h4>Emergency Contact</h4>
                                                            <hr />
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="7" >
                                                                <FloatingLabel controlId={`runner.${index}.emergencyName`} label="Full Name">
                                                                    <Form.Control
                                                                        required
                                                                        name={`runner.${index}.emergencyName`}
                                                                        type="text"
                                                                        placeholder="Full Name"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.runner[index].emergencyName}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].emergencyName &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].emergencyName
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].emergencyName
                                                                        }

                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].emergencyName}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            <Form.Group as={Col} md="5" className="mb-2  phone-float-input" >
                                                                <FloatingLabel controlId={`runner.${index}.emergencyContact`} label="Contact No">
                                                                    <PhoneInput
                                                                        id="select-input"
                                                                        name={`runner.${index}.emergencyContact`}
                                                                        className={
                                                                            "form-control " +
                                                                            (errors && errors.runner && errors.runner[index] && !!errors.runner[index].emergencyContact ? "is-invalid" : "") + " " +
                                                                            (touched.runner && touched.runner[index] && touched.runner[index].emergencyContact && errors.runner && errors.runner[index] && !errors.runner[index].contact ? "is-valid" : "")
                                                                        }
                                                                        country={'my'}
                                                                        inputProps={{
                                                                            name: `runner.${index}.emergencyContact`,
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        onChange={(phoneNumber, country, e) => { handleChange(e) }}
                                                                        value={values.runner[index].emergencyContact}
                                                                    />
                                                                    <Form.Control isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].emergencyContact} hidden />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].emergencyContact}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="12" >
                                                                <FloatingLabel controlId={`runner.${index}.medicalAttention`} label="Medical Attention">
                                                                    <Form.Control
                                                                        required
                                                                        name={`runner.${index}.medicalAttention`}
                                                                        type="text"
                                                                        placeholder="Medical Attention"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.runner[index].medicalAttention}
                                                                    />
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                        </Row>

                                                        <br /><br />

                                                        <Row className="mb-3">
                                                            <h4>Race Category</h4>
                                                            <hr />
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="12" >
                                                                <Form.Check
                                                                    inline
                                                                    label="42KM"
                                                                    name={`runner.${index}.category`}
                                                                    type="radio"
                                                                    id={`inline-radio"-1`}
                                                                    value="42KM"
                                                                    // onChange={handleMarathonTypeCheck}
                                                                    disabled={!ageCheck[index][0]}
                                                                    // disabled={true} // category closed
                                                                    checked={(runner.category === '42KM' ? true : false)}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleMarathonTypeCheck(e, index);
                                                                    }}
                                                                    isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].category}

                                                                    className={showDiv[0] ? 'd-none' : ''}
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label="21KM"
                                                                    name={`runner.${index}.category`}
                                                                    type="radio"
                                                                    id={`inline-radio"-2`}
                                                                    value="21KM"
                                                                    // onChange={handleMarathonTypeCheck}
                                                                    disabled={!ageCheck[index][1]}
                                                                    // disabled={true} // category closed
                                                                    checked={(runner.category === '21KM' ? true : false)}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleMarathonTypeCheck(e, index);
                                                                    }}
                                                                    isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].category}

                                                                    className={showDiv[1] ? 'd-none' : ''}
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label="10KM"
                                                                    name={`runner.${index}.category`}
                                                                    type="radio"
                                                                    id={`inline-radio"-3`}
                                                                    value="10KM"
                                                                    // onChange={handleMarathonTypeCheck}
                                                                    disabled={!ageCheck[index][2]}
                                                                    // disabled={true} // category closed
                                                                    checked={(runner.category === '10KM' ? true : false)}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleMarathonTypeCheck(e, index);
                                                                    }}
                                                                    isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].category}

                                                                    className={showDiv[2] ? 'd-none' : ''}
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label="5KM"
                                                                    name={`runner.${index}.category`}
                                                                    type="radio"
                                                                    id={`inline-radio"-4`}
                                                                    value="5KM"
                                                                    // onChange={handleMarathonTypeCheck}
                                                                    disabled={!ageCheck[index][3]}
                                                                    checked={(runner.category === '5KM' ? true : false)}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleMarathonTypeCheck(e, index);
                                                                    }}
                                                                    isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].category}

                                                                    className={showDiv[3] ? 'd-none' : ''}
                                                                />
                                                                <Form.Control id={`runner.${index}.selectedCategory`} isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].category} hidden />
                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].category}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className='mb-3'>
                                                            <Form.Group className="mb-2" as={Col} md="12" >
                                                                <label className="sub-label">Category :</label>
                                                                <Form.Check
                                                                    ref={ref => { elementRef.current[index] = ref }}
                                                                    inline
                                                                    label="Open"
                                                                    id={`runner.${index}.categoryType1`}
                                                                    name={`runner.${index}.categoryType`}
                                                                    type="radio"
                                                                    value="Open"
                                                                    disabled={!ageCheckVeteran[index][0]}
                                                                    checked={(runner.categoryType === "Open" ? true : false)}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleCategoryTypeCheck(e, index);
                                                                    }}
                                                                    isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].categoryType}
                                                                />
                                                                <Form.Check
                                                                    ref={ref => { elementRef2.current[index] = ref }}
                                                                    inline
                                                                    label="Veteran"
                                                                    id={`runner.${index}.categoryType2`}
                                                                    name={`runner.${index}.categoryType`}
                                                                    type="radio"
                                                                    value="Veteran"
                                                                    disabled={!ageCheckVeteran[index][1]}
                                                                    checked={(runner.categoryType === "Veteran" ? true : false)}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleCategoryTypeCheck(e, index);
                                                                    }}
                                                                    isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].categoryType}
                                                                />
                                                                <Form.Control id={`runner.${index}.categoryTypeSelected`} isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].categoryType} hidden />
                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].categoryType}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Row>

                                                        <br /><br />

                                                        <Row >
                                                            <h4>T-shirt Size</h4>
                                                            <hr />
                                                        </Row>
                                                        <Row className='mb-3'>
                                                            <Form.Group className="mb-2" as={Col} md="12" >
                                                                <b style={{ color: "white", }}>Size Chart</b>
                                                                <ol style={{ color: "white", }}>
                                                                    <li><small>Unisex T-shirt: <a href="https://www.marathonkuching.com/site/wp-content/uploads/2026/05/KM26-Event-Tee_Size-Chart-1024x1024.png" target="_blank">view</a></small></li>
                                                                    <li><small>Male Singlet: <a href="https://www.marathonkuching.com/site/wp-content/uploads/2026/05/KM26-Male_Singlet-Size-Chart-3-1024x1024.png" target="_blank">view</a></small></li>
                                                                    <li><small>Female Singlet: <a href="https://www.marathonkuching.com/site/wp-content/uploads/2026/05/KM26-Female_Singlet-Size-Chart-1024x1024.png" target="_blank">view</a></small></li>
                                                                </ol>
                                                                <label className="sub-label mt-3">Running Shirt Type :</label>
                                                                <Form.Check
                                                                    inline
                                                                    label="T-shirt"
                                                                    id={`runner.${index}.tshirt_type1`}
                                                                    name={`runner.${index}.tshirt_type`}
                                                                    type="radio"
                                                                    value="T-shirt"
                                                                    checked={(runner.tshirt_type === "T-shirt" ? true : false)}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleShirtTypeCheck(e, index);
                                                                    }}
                                                                    isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].tshirt_type}
                                                                />
                                                                {tshirtTypeEnable && (
                                                                    <>
                                                                        <Form.Check
                                                                            inline
                                                                            label="Singlet"
                                                                            id={`runner.${index}.tshirt_type2`}
                                                                            name={`runner.${index}.tshirt_type`}
                                                                            type="radio"
                                                                            value="Singlet"
                                                                            checked={(runner.tshirt_type === "Singlet" ? true : false)}
                                                                            onChange={(e) => {
                                                                                handleChange(e);
                                                                                handleShirtTypeCheck(e, index);
                                                                            }}
                                                                            isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].tshirt_type}
                                                                        />
                                                                    </>
                                                                )}
                                                                <Form.Control id={`runner.${index}.tshirt_typeSelected`} isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].tshirt_type} hidden />
                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].tshirt_type}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Row>

                                                        {runner.tshirt_type != "" && (
                                                            <>
                                                                <Row className="mb-3">
                                                                    <Form.Group className="mb-2" as={Col} md="12" >

                                                                        {size.map((s, i) => (
                                                                            <Form.Check
                                                                                inline
                                                                                label={s}
                                                                                name={`runner.${index}.tshirt_size`}
                                                                                type="radio"
                                                                                value={s}
                                                                                id={`tshirt-${i + 1}`}
                                                                                // disabled={!categoryCheck[index]}
                                                                                // disabled={!hasTshirt[i]}
                                                                                disabled={!hasTshirt2[index][i]}
                                                                                onChange={(e) => {
                                                                                    handleChange(e);
                                                                                    handleTshirtCheck(e, index);
                                                                                }}
                                                                                checked={(runners.runner[index].tshirt_size === s ? true : false)}
                                                                                isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].tshirt_size}

                                                                                key={i}
                                                                            />
                                                                        ))}

                                                                        <Form.Control id={`runner.${index}.TshirtSelected`} isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].tshirt_size} hidden />
                                                                        <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].tshirt_size}</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Row>
                                                            </>
                                                        )}

                                                        {isMarathon[index] && (
                                                            <>
                                                                <br /><br />
                                                                <Row className="mb-3">
                                                                    <h4>Finisher Size</h4>
                                                                    <hr />
                                                                </Row>
                                                                <Row className="mb-3">
                                                                    <Form.Group className="mb-2" as={Col} md="12" >

                                                                        {size.map((s, i) => (
                                                                            <Form.Check
                                                                                inline
                                                                                label={s}
                                                                                name={`runner.${index}.finisher`}
                                                                                type="radio"
                                                                                id={`finisher-${i + 1}`}
                                                                                // disabled={!isMarathon[index]}
                                                                                disabled={!hasFinisher[index][i]}
                                                                                onChange={(e) => {
                                                                                    handleChange(e);
                                                                                    handleFinisher(e, index);
                                                                                }}
                                                                                checked={(runners.runner[index].finisher === s ? true : false)}
                                                                                value={s}
                                                                                isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].finisher}

                                                                                key={i}
                                                                            />
                                                                        ))}

                                                                        <Form.Control id={`runner.${index}.selectedFinisher`} isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].finisher} hidden />
                                                                        <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].finisher}</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Row>
                                                            </>
                                                        )}

                                                        <br /><br />

                                                        <Row className="mb-3">
                                                            <h4>Race Pack Collection</h4>
                                                            <hr />
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="12"  >
                                                                <Form.Check
                                                                    inline
                                                                    label="Self Collect"
                                                                    id={`colection-1`}
                                                                    name={`runner.${index}.racePackCollection`}
                                                                    type="radio"
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleDelivery(e, index);
                                                                    }}
                                                                    checked={(runners.runner[index].racePackCollection === 'Self-Collect' ? true : false)}
                                                                    value="Self-Collect"
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label="Delivery Service"
                                                                    id={`collection-2`}
                                                                    name={`runner.${index}.racePackCollection`}
                                                                    type="radio"
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleDelivery(e, index);
                                                                    }}
                                                                    checked={(runners.runner[index].racePackCollection === 'Delivery Service' ? true : false)}
                                                                    value="Delivery Service"
                                                                    disabled={true} // delivery service function closed
                                                                />
                                                            </Form.Group>

                                                            {isDelivery[index] && (
                                                                <>
                                                                    <hr />

                                                                    <Form.Group className="mb-3 mt-2" id="formGridCheckbox">
                                                                        <Row style={{ color: 'white' }}>
                                                                            <Col md="12">
                                                                                <h5>Courier Service Partner :</h5>
                                                                                <img style={{ marginLeft: '10px', width: '200px' }} src="https://marathonkuching.com/register/images/pos_malaysia_2026.png" />
                                                                                <br />
                                                                                <strong style={{ fontSize: '2rem' }}>Pos Malaysia Berhad</strong>
                                                                            </Col>
                                                                        </Row>
                                                                        {/* <Form.Check
                                                                            type="checkbox"
                                                                            label="Use my address"
                                                                            onChange={(e) => { handleIsMyAddress(e, index) }}
                                                                            checked={isMyAddress[index]}
                                                                        /> */}
                                                                    </Form.Group>

                                                                    <Row className="mb-3">
                                                                        <Form.Group className="mb-2" as={Col} md="12" >
                                                                            <FloatingLabel controlId={`runner.${index}.deliveryAddress`} label="Address">
                                                                                <Form.Control
                                                                                    required
                                                                                    as="textarea"
                                                                                    placeholder="Address"
                                                                                    style={{ height: '100px' }}
                                                                                    name={`runner.${index}.deliveryAddress`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.runner[index].deliveryAddress}
                                                                                    isValid={
                                                                                        touched.runner && touched.runner[index] && touched.runner[index].deliveryAddress &&
                                                                                        errors.runner && errors.runner[index] && !errors.runner[index].deliveryAddress
                                                                                    }
                                                                                    isInvalid={
                                                                                        errors && errors.runner && errors.runner[index] && !!errors.runner[index].deliveryAddress
                                                                                    }
                                                                                />
                                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].deliveryAddress}</Form.Control.Feedback>
                                                                            </FloatingLabel>
                                                                        </Form.Group>
                                                                        <Form.Group className="mb-2" as={Col} md="6" >
                                                                            <FloatingLabel controlId={`runner.${index}.deliveryPostcode`} label="Postcode">
                                                                                <Form.Control
                                                                                    required
                                                                                    name={`runner.${index}.deliveryPostcode`}
                                                                                    type="text"
                                                                                    placeholder="Postcode"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.runner[index].deliveryPostcode}
                                                                                    isValid={
                                                                                        touched.runner && touched.runner[index] && touched.runner[index].deliveryPostcode &&
                                                                                        errors.runner && errors.runner[index] && !errors.runner[index].deliveryPostcode
                                                                                    }
                                                                                    isInvalid={
                                                                                        errors && errors.runner && errors.runner[index] && !!errors.runner[index].deliveryPostcode
                                                                                    }

                                                                                />
                                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].deliveryPostcode}</Form.Control.Feedback>
                                                                            </FloatingLabel>
                                                                        </Form.Group>
                                                                        <Form.Group className="mb-2" as={Col} md="6" >
                                                                            <FloatingLabel controlId={`runner.${index}.deliveryCity`} label="City">
                                                                                <Form.Control
                                                                                    required
                                                                                    name={`runner.${index}.deliveryCity`}
                                                                                    type="text"
                                                                                    placeholder="City"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.runner[index].deliveryCity}
                                                                                    isValid={
                                                                                        touched.runner && touched.runner[index] && touched.runner[index].deliveryCity &&
                                                                                        errors.runner && errors.runner[index] && !errors.runner[index].deliveryCity
                                                                                    }
                                                                                    isInvalid={
                                                                                        errors && errors.runner && errors.runner[index] && !!errors.runner[index].deliveryCity
                                                                                    }

                                                                                />
                                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].deliveryCity}</Form.Control.Feedback>
                                                                            </FloatingLabel>
                                                                        </Form.Group>
                                                                        <Form.Group className="mb-2" as={Col} md="6" >
                                                                            <FloatingLabel controlId={`runner.${index}.deliveryState`} label="State">
                                                                                <Form.Control
                                                                                    required
                                                                                    name={`runner.${index}.deliveryState`}
                                                                                    type="text"
                                                                                    placeholder="Last name"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.runner[index].deliveryState}
                                                                                    isValid={
                                                                                        touched.runner && touched.runner[index] && touched.runner[index].deliveryState &&
                                                                                        errors.runner && errors.runner[index] && !errors.runner[index].deliveryState
                                                                                    }
                                                                                    isInvalid={
                                                                                        errors && errors.runner && errors.runner[index] && !!errors.runner[index].deliveryState
                                                                                    }

                                                                                />
                                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].deliveryState}</Form.Control.Feedback>
                                                                            </FloatingLabel>
                                                                        </Form.Group>
                                                                        <Form.Group className="mb-2" as={Col} md="6" >
                                                                            <FloatingLabel controlId={`runner.${index}.deliveryCountry`} label="Country">
                                                                                <Form.Select
                                                                                    aria-label="Default select example"
                                                                                    name={`runner.${index}.deliveryCountry`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.runner[index].deliveryCountry}
                                                                                    isValid={
                                                                                        touched.runner && touched.runner[index] && touched.runner[index].deliveryCountry &&
                                                                                        errors.runner && errors.runner[index] && !errors.runner[index].deliveryCountry
                                                                                    }
                                                                                    isInvalid={
                                                                                        errors && errors.runner && errors.runner[index] && !!errors.runner[index].deliveryCountry
                                                                                    }
                                                                                >
                                                                                    <option key="" value="">Select a country</option>
                                                                                    <option key="Malaysia" value="Malaysia">Malaysia</option>
                                                                                    {/* <option key="Singapore" value="Singapore">Singapore</option> */}
                                                                                    {/* <option key="Brunei" value="Brunei">Brunei</option> */}
                                                                                </Form.Select>
                                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].deliveryCountry}</Form.Control.Feedback>
                                                                            </FloatingLabel>
                                                                        </Form.Group>
                                                                    </Row>
                                                                </>
                                                            )}

                                                        </Row>

                                                    </div>


                                                </div>
                                            ))}
                                        </>
                                    )}
                                </FieldArray>

                            </Col>
                            <Col md={4} xs={12} >
                                <div id="regChart" className="mTop5">

                                    <Row className="chartTitle">
                                        <h5>Registration Summary</h5>
                                    </Row>

                                    <hr />

                                    <Row className="chartDesc">
                                        <h6>Kuching Marathon 2026</h6>
                                        <span>27 September 2026</span>
                                    </Row>

                                    <div className="chartItemBox">
                                        <ul className="chartItemList">
                                            {runners.runner && runners.runner.length > 0 && runners.runner.map((values, index) => (
                                                <li key={index}>
                                                    <div className="subChartTitle">
                                                        <h6>Participant {index + 1}</h6>
                                                    </div>
                                                    <div className="subChartDetail">
                                                        <p className='subChartDetailLeft'>{values.category === '' ? 'Not selected' : marathonLabel[values.category]}</p>
                                                        <p className='subChartDetailRight'>RM {values.category === '' ? 0 : marathonPrice[values.category]}</p>
                                                    </div>
                                                    {values.racePackCollection == "Delivery Service" && (
                                                        <div className="subChartDetail">
                                                            <p className='subChartDetailLeft'>Delivery Service</p>
                                                            <p className='subChartDetailRight'>RM 20</p>
                                                        </div>
                                                    )}
                                                </li>
                                            ))}
                                            {runners.runner.length === 0 && (
                                                <div className="subChartEmpty">
                                                    <h6>Item cart is empty.</h6>
                                                </div>
                                            )}
                                        </ul>
                                    </div>

                                    <hr />

                                    <Row className="promo">
                                        <FloatingLabel controlId="floatingPromo" label="Promo Code">
                                            <Form.Control type="text" placeholder="Promo Code" onChange={handlePromo} value={promo} />
                                        </FloatingLabel>
                                    </Row>

                                    <hr />

                                    {error && (
                                        <Col md={12} xs={12}>
                                            <Alert variant="danger" onClose={() => { setError(false); setIsMe(false) }} dismissible>
                                                {errorMessage}
                                            </Alert>
                                        </Col>
                                    )}

                                    {notice && (
                                        <Col md={12} xs={12}>
                                            <Alert variant="success" onClose={() => { setNotice(false); setNoticeMessage('') }} dismissible>
                                                {noticeMessage}
                                            </Alert>
                                        </Col>
                                    )}

                                    {errors && !Array.isArray(errors.runner) && errors.runner && (
                                        <Col md={12} xs={12} className='p-2'>
                                            <Alert variant="danger" onClose={() => { setError(false); setIsMe(false) }} >
                                                {errors.runner}
                                            </Alert>
                                        </Col>
                                    )}

                                    {isUpdate ? (
                                        <>
                                            <Row className="chartTotal chartItemList">
                                                <div className="chartTotal subChartDetail">
                                                    <p className='chartTotalLeft subChartDetailLeft'>Subtotal</p>
                                                    <p className='chartTotalRight subChartDetailRight'>RM <span>{cartSubtotal}</span></p>
                                                </div>
                                                <div className="chartTotal subChartDetail">
                                                    <p className='chartTotalLeft subChartDetailLeft'>Tax (8%)</p>
                                                    <p className='chartTotalRight subChartDetailRight'>RM <span>{cartTax}</span></p>
                                                </div>
                                                <div className="chartTotal subChartDetail">
                                                    <p className='chartTotalLeft subChartDetailLeft'>Total</p>
                                                    <p className='chartTotalRight subChartDetailRight'>RM <span>{cartTotal}</span></p>
                                                </div>
                                                <Col>
                                                    <Button type="submit" className="btn red-button form-control d-flex justify-content-center">
                                                        Proceed &nbsp;
                                                        <TailSpin
                                                            height="18"
                                                            width="18"
                                                            color="#ccc"
                                                            ariaLabel="tail-spin-loading"
                                                            radius="2"
                                                            wrapperStyle={{}}
                                                            wrapperClass="loader"
                                                            visible={loading}
                                                        />
                                                    </Button>
                                                </Col>
                                            </Row>

                                            <hr />
                                        </>
                                    ) : (
                                        <>
                                            <Row className="chartTotal chartItemList">
                                                <div className="chartTotal subChartDetail">
                                                    <p className='chartTotalLeft subChartDetailLeft'>Subtotal</p>
                                                    <p className='chartTotalRight subChartDetailRight'>RM <span>{cartSubtotal}</span></p>
                                                </div>
                                                <div className="chartTotal subChartDetail">
                                                    <p className='chartTotalLeft subChartDetailLeft'>Tax (8%)</p>
                                                    <p className='chartTotalRight subChartDetailRight'>RM <span>{cartTax}</span></p>
                                                </div>
                                                <div className="chartTotal subChartDetail">
                                                    <p className='chartTotalLeft subChartDetailLeft'>Total</p>
                                                    <p className='chartTotalRight subChartDetailRight'>RM <span>{cartTotal}</span></p>
                                                </div>
                                                <Col>
                                                    <Button type="submit" className="btn red-button form-control d-flex justify-content-center">
                                                        Proceed &nbsp;
                                                        <TailSpin
                                                            height="18"
                                                            width="18"
                                                            color="#ccc"
                                                            ariaLabel="tail-spin-loading"
                                                            radius="2"
                                                            wrapperStyle={{}}
                                                            wrapperClass="loader"
                                                            visible={loading}
                                                        />
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </>
                                    )}

                                    {/* <Alert id="sessionTimer" variant="info">
                                        Registration session will be expired in 5:00
                                    </Alert> */}

                                </div>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>

        </Container>
    );
}

export default Register;